/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Message_LabelInputs */

const en_templates_message_label = /** @type {(inputs: Templates_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const he_templates_message_label = /** @type {(inputs: Templates_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הודעה`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Templates_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_message_label = /** @type {((inputs?: Templates_Message_LabelInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Message_LabelInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_message_label(inputs)
	return he_templates_message_label(inputs)
});